import getRealDate from '@sdk/utils/getRealDate';

export function extendTimesheetEntry(model: { timestamp: string }) {
  return {
    ...model,
    timestamp: getRealDate(model.timestamp),
    timestampLocal: new Date(model.timestamp)
  };
}
